export default "__VITE_ASSET__BCfji5____"